// extracted by mini-css-extract-plugin
export default {"main":"Fba_main__f9u0b"};